import React from 'react';

export default function AdBanner({ visible = true }) {
    if (!visible) return null;
    return (
        <div
            className="w-full h-16 bg-gradient-to-r from-rose-100 to-amber-100 border-y border-rose-200 flex items-center justify-center relative"
            data-testid="ad-banner"
        >
            <span className="absolute left-2 top-1/2 -translate-y-1/2 -rotate-90 origin-center text-[9px] font-bold text-rose-400 tracking-widest uppercase">PUBLICIDAD</span>
            <div className="text-sm font-medium text-rose-600/70">Espacio para anuncio</div>
        </div>
    );
}
